import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearCart } from "../../redux/actions";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutInformation from "./CheckoutInformation";
import CheckoutCart from "./CheckoutCart";
import "../../css/Checkout.css";
import { createOrder } from "../../api/orderApi";

const CheckoutForm = () => {
  const cartItems = useSelector((state) => state.cart.cartItems);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [tableNumber, setTableNumber] = useState("");
  const [cardHolder, setCardHolder] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const { menuId, restaurantId } = useParams();
  const [orderSuccess, setOrderSuccess] = useState(false);

  const totalAmount = cartItems.reduce(
    (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
    0
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const order = {
      customerName: name,
      tableNumber: parseInt(tableNumber),
      totalAmount,
      restaurantId: parseInt(restaurantId),
      items: cartItems.map(({ id, price, quantity }) => ({
        itemId: id,
        quantity,
        price,
      })),
    };
    console.log("order", order);

    try {
      await createOrder(order);
      dispatch(clearCart());
      setOrderSuccess(true);
      //navigate(`/menu/${menuId}`);
    } catch (error) {
      alert("Failed to place order.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="checkout-form">
      <CheckoutInformation
        name={name}
        setName={setName}
        tableNumber={tableNumber}
        setTableNumber={setTableNumber}
        cardHolder={cardHolder}
        setCardHolder={setCardHolder}
        cardNumber={cardNumber}
        setCardNumber={setCardNumber}
        expiry={expiry}
        setExpiry={setExpiry}
        cvv={cvv}
        setCvv={setCvv}
      />
      <CheckoutCart cartItems={cartItems} />
      <button
        type="submit"
        className="checkout-submit"
        disabled={cartItems.length === 0 || totalAmount <= 0}
      >
        Confirm Order
      </button>
      {orderSuccess && (
        <div className="order-confirmation-modal">
          <div className="order-confirmation-content">
            <h2>Order Placed!</h2>
            <p>
              Thank you, {name}. Your order for Table #{tableNumber} has been
              received.
            </p>
            <button onClick={() => navigate(`/menu/${menuId}`)}>
              Back to Menu
            </button>
          </div>
        </div>
      )}
    </form>
  );
};

export default CheckoutForm;
